import { useContext, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Container, Divider, Grid, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../routing/LangRouter";

//import constants
import { RULES } from "../../constants/rules";
import { IS_MOBILE } from "../../constants/breakpoints";

//import general components
import Footer from "../../components/common/footer/footer";

//import images and icons
import { ArrowDown2 } from "iconsax-react";

//import styles
import "./rules.scss";

function Rules() {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    const [expanded, setExpanded] = useState(false);
    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <>
            <Grid className="rules" mt={{ xs: 2, md: 0 }} mb={15}>
                <Container maxWidth="xl">
                    <Grid className="rules__title" container item xs={12} direction="column">
                        <h1>{t("dearUser")}،</h1>
                        <span>{t("textRuls1")}</span>
                        <span>{t("textRuls2")}</span>
                    </Grid>
                    <Grid container item xs={12} rowGap={{ xs: 2, md: 4 }} mt={{ xs: 5, md: 0 }}>
                        {RULES.map(rule => {
                            return (
                                <Accordion
                                    defaultExpanded={IS_MOBILE ? false : true}
                                    expanded={expanded === rule?.id}
                                    onChange={handleChange(rule?.id)}
                                    sx={{
                                        width: "100%",
                                        borderRadius: "0.625rem !important",
                                        backgroundColor: "var(--white-gray-color)",
                                        boxShadow: "0px 0px 1px 0px rgba(0, 0, 0, 0.60)",
                                        margin: "0 !important",
                                        "&::before": {
                                            display: "none",
                                        },
                                    }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ArrowDown2 color="var(--light-color)" />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        sx={{
                                            minHeight: "fit-content !important",
                                            flexDirection: "row-reverse !important",
                                            columnGap: "1rem",
                                            padding: "0 16px",
                                            borderRadius: "0.625rem",
                                            backgroundColor: "var(--primary-color)",
                                            "& .MuiTypography-root": {
                                                color: "var(--light-color)",
                                                fontWeight: "bold",
                                            },
                                            "& .MuiAccordionSummary-content": {
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                margin: "10px 0 !important",
                                            },

                                            "&.Mui-expanded": {
                                                backgroundColor: "transparent",
                                                "& .MuiTypography-root": {
                                                    color: "var(--primary-color)",
                                                },
                                                "& .MuiAccordionSummary-expandIconWrapper": {
                                                    path: {
                                                        stroke: "var(--primary-color)",
                                                    },
                                                },
                                            },
                                        }}
                                    >
                                        <Typography sx={{ fontSize: { xs: "0.875rem", md: "1rem" } }}>{rule?.title[locale]}</Typography>
                                        {!IS_MOBILE && <Divider width="85%" sx={{ borderBottomColor: "var(--primary-color)" }} />}
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ padding: { xs: 0 } }}>
                                        <List>
                                            {rule?.description?.[locale]?.map(descriptionItem => {
                                                return (
                                                    <ListItem sx={{ columnGap: "1rem", alignItems: "flex-start", textAlign: "justify" }}>
                                                        <span className="rules__point"></span>
                                                        <ListItemText
                                                            primary={descriptionItem}
                                                            sx={{
                                                                "& .MuiListItemText-primary": { fontSize: { xs: "0.875rem", md: "1rem" } },
                                                            }}
                                                        />
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    </AccordionDetails>
                                </Accordion>
                            );
                        })}
                    </Grid>
                </Container>
            </Grid>
            <Footer />
        </>
    );
}

export default Rules;
